import { OrderChangesHistory } from '../../../../../api/services/orders/types.ts'
import { splitDateString } from '../../../../../utils/dates.ts'

const ItemCard = ({
  item,
  divStyles = 'text-title-xsm border my-2 p-4 bg-gray-100 dark:bg-gray-700 rounded shadow-md'
}: {
  item: OrderChangesHistory
  divStyles?: string
}) => {
  if (!item) return null

  return (
    <div className={divStyles} key={item.created_at}>
      {item.planned_share_date && (
        <p className="mb-1">
          <span className="font-bold">
            Bieżący folder
          </span>
        </p>
      )}
      <p className="mb-1">
        <span>Nazwa wybranego folderu: </span>
        <span className="font-bold">{Object.keys(item.folder).length > 0 ? item.folder?.folder_name : 'folder usunięty'}</span>
      </p>
      <p className="mb-1">
        <span className="">Liczba posiłków: </span>
        <span className="font-bold">{Object.keys(item.folder).length > 0 ? item.folder?.number_of_meals : 'brak informacji'}</span>
      </p>
      <p className="mb-1">
        <span>Liczba kalorii: </span>
        <span className="font-bold">{item.folder?.kcal}</span>
      </p>
      <p className="text-sm mb-1">{`( wprowadzono: ${splitDateString(item.created_at).date} godz: ${splitDateString(item.created_at).time} )`}</p>
    </div>
  )
}

export default ItemCard

// HOC with modified main div styles
export const withDivStyles = <P extends object>(
  WrappedComponent: React.ComponentType<P>, // The original component (ItemCard)
  divStyles: string // Additional styles for the main div
) => {
  return (props: P) => {
    return <WrappedComponent {...props} divStyles={divStyles} />
  }
}
